import React from "react";
import styles from './TermsOfUse.module.scss';
import CustomCheckbox from '../forms/CustomCheckbox';

interface TermsOfUseProps {
  termsAccepted: boolean,
  setTermsAccepted: (accepted: boolean) => void;
  additionalMessages?: string[];
}

const termsUrl = process.env.REACT_APP_LANDING + "/terms-of-use"

const TermsOfUse: React.FC<TermsOfUseProps> = ({ termsAccepted, setTermsAccepted, additionalMessages = [] }) => {
  return (
    <div className={styles.title}>
      <CustomCheckbox
        label={
          <>
            I agree to{' '}
            <a href={termsUrl} target="_blank" rel="noreferrer">
              Terms of Use
            </a>
          </>
        }
        isChecked={termsAccepted}
        handleChange={(event) => setTermsAccepted(event.target.checked)}
      />
      {additionalMessages.map((message, index) => (
        <p className={styles.message} key={index}>{message}</p>
      ))}
      <span className={styles.message}>
        There are no refunds. Your subscription will renew automatically, and you will be charged in advance. You may cancel at any time. The cancellation goes into effect at the start of your following billing cycle.</span>
    </div>
  );
};

export default TermsOfUse;
